export const getLastDateInMonth = (fleetReportTerm) => {
  const fleetReportTermDate = new Date(fleetReportTerm)
  const lastDay = new Date(fleetReportTermDate.getFullYear(), fleetReportTermDate.getMonth() + 1, 0)
  const month = String(lastDay.getMonth() + 1).length === 1 ? '0' + (lastDay.getMonth() + 1) : lastDay.getMonth() + 1
  const strMonth = lastDay.getFullYear() + '-' + month + '-' + lastDay.getDate()
  return strMonth
}

export default getLastDateInMonth
